import { getValidator } from '@/api/apiMain';
import { useQuery } from '@tanstack/vue-query';

export default function useValidator() {
  return useQuery({
    queryKey: ['validator'],
    queryFn: getValidator,
    staleTime: 1000 * 60 * 60 * 24,
  });
}
